import { FC } from 'react'
import { IconPaths } from '_metronic/helpers'
import styles from '../../Prescricao.module.scss'
import { Icone } from '../comum/Icone'
import { useRotulos } from '../comum/useRotulos'
import { Button } from 'app/components'

export type PendenciaRevisao = {
  id: string
  /** Onde está o problema: "Item 2", "Orientações", "SNCR RCE", "Envio". */
  onde: string
  /** O que falta: "posologia", "telefone"… */
  oque: string
  /** Leva ao campo: fecha o drawer e abre o card, ou foca o campo no próprio drawer. */
  ir: () => void
}

/** Checklist do que impede a assinatura; cada linha leva ao campo correspondente. */
export const SecaoPendencias: FC<{ pendencias: PendenciaRevisao[] }> = ({ pendencias }) => {
  const { t } = useRotulos()
  const bloqueada = pendencias.length > 0

  return (
    <section
      aria-labelledby='revisao-pendencias'
      className={`${styles.secao} ${bloqueada ? styles.secaoPendencias : styles.secaoPronta}`}
    >
      <h3
        id='revisao-pendencias'
        className={`fs-6 fw-bold m-0 d-flex align-items-center gap-2 ${
          bloqueada ? styles.pendenciaErro : styles.estadoOk
        }`}
      >
        <Icone icone={bloqueada ? IconPaths.Alert : IconPaths.CircleCheck} className='fs-3' />
        {bloqueada
          ? t('prescricao.revisao.pendencias', { quantidade: pendencias.length })
          : t('prescricao.revisao.pronto')}
      </h3>
      {bloqueada && (
        <ul className='list-unstyled m-0 mt-2'>
          {pendencias.map((pendencia) => (
            <li key={pendencia.id}>
              <Button className={styles.linkPendencia} onClick={pendencia.ir} unstyled>
                <Icone icone={IconPaths.Alert} />
                <span>
                  <strong>{pendencia.onde}</strong> · {pendencia.oque}
                </span>
                <Icone icone={IconPaths.ArrowRight} className='ms-auto fs-4' />
              </Button>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
